import React from 'react';
import { Box, Text } from '@rsos/components/capstone/base';
import formatDate from '../../../formatDate';
import { TextArea } from '../ReviewModal.styles';

const CommentArea = ({ comments, comment, onChange, isEditing }) => {
  return (
    <Box width="100%" mt="10px" flow={5}>
      {!isEditing ? (
        comments.map(comment => (
          <Box key={comment.author}>
            <Box horizontal justify="space-between">
              <Text size="small" fontWeight="semibold" color="secondaryText">
                {comment.author}
              </Text>
              <Text size="small" fontWeight="semibold" color="secondaryText">
                {formatDate(comment.created)}
              </Text>
            </Box>
            <Text size="small" color="secondaryText">
              {comment.body}
            </Text>
          </Box>
        ))
      ) : (
        <>
          <Text size="small" mb="10px" color="secondaryText">
            You {formatDate(new Date().toISOString())}
          </Text>
          <TextArea
            placeholder="Enter your text here"
            value={comment}
            onChange={onChange}
          ></TextArea>
        </>
      )}
    </Box>
  );
};

export default CommentArea;
